



































import { defineComponent, onMounted, PropType, computed } from '@nuxtjs/composition-api';
import ProductListItemComponent from '~/components/pages/Product/ProductListItem.vue';
import AppSortSelect from '~/components/partials/App/AppSortSelect.vue';
import { useListFavorite } from '~/composables/contents/useListFavorite';
import { usePropSync } from '~/composables/usePropSync';
import { useStore } from '~/composables/useStore';
import { useWOVNio } from '~/composables/wovn/useWOVNio';
import { PRODUCT_SEARCH_SORT_OPTIONS } from '~/constants';
import { ProductListItem } from '~/types/modules/product';
import { FavoriteTypes } from '~/enums';

export default defineComponent({
  components: {
    AppSortSelect,
    ProductListItem: ProductListItemComponent,
  },
  props: {
    products: {
      type: Array as PropType<ProductListItem[]>,
      required: true,
    },
    totalNumber: {
      type: Number,
      required: true,
    },
    currentIndex: {
      type: Number,
      required: true,
    },
    hasStock: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const store = useStore();
    const { syncedCurrentIndex, syncedHasStock } = usePropSync(props, 'currentIndex', 'hasStock');
    const { currentLang } = useWOVNio();
    const { fetchAllFavorites } = useListFavorite();

    const authenticated = computed(() => store.state.auth.authenticated);

    onMounted(async () => {
      fetchAllFavorites(FavoriteTypes.ITEM);

      if (!authenticated.value) return;

      try {
        await store.dispatch('modules/lottery/fetchLotteryApplications', {
          query: { is_applying: true },
        });
      } catch {
        // 何もしない
      }
    });

    return { PRODUCT_SEARCH_SORT_OPTIONS, syncedCurrentIndex, syncedHasStock, currentLang };
  },
});
